module.exports = __webpack_public_path__ + "static/media/Raghu Karamsetty.e520feb4.png";